import React from 'react';
import { observer } from 'mobx-react-lite';
import { NotFoundPage } from '../../../../mainv2/containers/common/NotFoundPage';
import { GlobalLoader } from '../../../../mainv2/components/GlobalLoader';
import { ReservationCompletePane } from '../../molecules/reservations/ReservationCompletePane';
import { useEventReservationState } from './states/EventPaneState';

type Props = {
  eventId: number;
};

export const EventReservationComplete = observer((props: Props) => {
  const { event } = useEventReservationState(props.eventId);
  if (event.isNotFound()) {
    return <NotFoundPage entityType="イベント" />;
  }
  if (event.loading) {
    return <GlobalLoader />;
  }
  return <ReservationCompletePane reservable={event.get()} />;
});
